<template>
    <div>		
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.searchValue1" class="input-with-select" size="small">
                        <el-select v-model="params.searchType1" slot="prepend" placeholder="请选择">
                            <el-option label="手机号" :value="1"></el-option>
                            <el-option label="购买人id" :value="2"></el-option>
                            <el-option label="观演人证件号" :value="3"></el-option>
							<el-option label="观演人姓名" :value="4"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
				    <el-input v-model="params.searchValue2" class="input-with-select" size="small">
				        <el-select v-model="params.searchType2" slot="prepend" placeholder="请选择">
				            <el-option label="订单编号" :value="1"></el-option>
				            <el-option label="运单号" :value="2"></el-option>
				            <el-option label="外部渠道订单编号" :value="3"></el-option>
							<el-option label="支付平台交易号" :value="4"></el-option>
				        </el-select>
				    </el-input>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
				    <el-input v-model="params.searchValue3" class="input-with-select" size="small">
				        <el-select v-model="params.searchType3" slot="prepend" placeholder="请选择">
				            <el-option label="演出名称" :value="1"></el-option>
				            <el-option label="演出id" :value="2"></el-option>
				            <el-option label="商品名称" :value="3"></el-option>
							<el-option label="商品id" :value="4"></el-option>
							<el-option label="众筹名称" :value="5"></el-option>
							<el-option label="众筹id" :value="6"></el-option>
				        </el-select>
				    </el-input>
				</el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.orderStatus" placeholder="请选择" size="small">
                        <el-option label="仅看待处理的" :value="1"></el-option>
                        <el-option label="仅看待发货的" :value="2"></el-option>
						<el-option label="仅看已发货的" :value="4"></el-option>
						<el-option label="仅看已完成的" :value="5"></el-option>
						<el-option label="仅看已过期的" :value="6"></el-option>
						<el-option label="仅看已取消的" :value="7"></el-option>
						<el-option label="仅看有效的" :value="8"></el-option>						
                        <el-option label="不限制订单状态" :value="0"></el-option>
                    </el-select>
                </el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
				    <el-select v-model="params.payStatus" placeholder="请选择" size="small">
				        <el-option label="仅看未支付的" :value="1"></el-option>
				        <el-option label="仅看已支付的" :value="2"></el-option>
				        <el-option label="不限制支付状态" :value="0"></el-option>
				    </el-select>
				</el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="5" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
		
		<el-card shadow="never" v-if="userInfo && userInfo.userId != ''">
		    <div slot="header">
		        用户信息
		        <span class="ML20">
					<el-button type="primary" size="small" @click="goTicketWallet(userInfo.userId)" v-if="userInfo && userInfo.userId != '' && $utils.have('/callCenter/walletList')" >查看用户票夹</el-button>
				</span>
		    </div>
			<el-row :gutter="40">
			    <el-col :xs="24" :sm="12" :md="8"><span class="color-info">用户 ID: </span>{{userInfo.userId}}</el-col>
			    <el-col :xs="24" :sm="12" :md="8"><span class="color-info">用户昵称: </span>{{userInfo.useName}}</el-col>
			    <el-col :xs="24" :sm="12" :md="8"><span class="color-info">账号手机: </span>{{userInfo.areaCode}} {{userInfo.tel}} </el-col>
			    <el-col :xs="24" :sm="12" :md="8"><span class="color-info">支付订单数: </span>{{userInfo.orderNum}}</el-col>
			    <el-col :xs="24" :sm="12" :md="8"><span class="color-info">身份: </span>
					<span v-if="userInfo.userType == 1">乐迷</span>
					<span v-else-if="userInfo.userType == 2">艺人</span>
					<span v-else-if="userInfo.userType == 3">场地</span>
					<span v-else-if="userInfo.userType == 3">厂牌</span>
				</el-col>
			    <el-col :xs="24" :sm="12" :md="8"><span class="color-info">来源渠道: </span>{{userInfo.source}}</el-col>
			    <el-col :xs="24" :sm="12" :md="8"><span class="color-info">注册终端: </span>{{userInfo.terminal}}</el-col>
			    <el-col :xs="24" :sm="12" :md="8"><span class="color-info">注册时间: </span>{{userInfo.registerTime}}</el-col>
			    <el-col :xs="24" :sm="12" :md="8"><span class="color-info">最近登录城市: </span>{{userInfo.city}}</el-col>
				<el-col :xs="24" :sm="12" :md="8"><span class="color-info">最近登录时间: </span>{{userInfo.lastLoginTime}}</el-col>
				<!-- 未成年模式密码（有返回说明开启了青少年模式，没返回则不展示） -->
				<el-col :xs="24" :sm="12" :md="8" v-if="userInfo.youthModePassword"><span class="color-info">未成年模式密码: </span>{{userInfo.youthModePassword}}</el-col>
			</el-row>
		</el-card>
        <div class="page-list-box" v-if="dataList">
            <el-table
                :data="dataList.slice((currentPage - 1) * pageSize, currentPage * pageSize)"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column type="expand" label="展开">
                    <template slot-scope="props">
                        <div v-if="props.row.afterSales && props.row.afterSales.length > 0 ">
                            <div v-for="(item,index) in props.row.afterSales" :key="index" class="PD10">
								<template  v-if="props.row.orderType == 1 ">
									<span><span class="color-info">来源：</span>{{source.get(item.source)}}</span>
									<span class="ML20"><span class="color-info">售后状态：</span>{{afterSalesStatus.get(item.afterSalesStatus)}}</span>
									<span class="ML20"><span class="color-info">申请退票数量：</span>{{item.refundNum}}</span>
									<span class="ML20"><span class="color-info">申请退款金额：</span>{{item.refundAmount}}</span>
									<span class="ML20"><span class="color-info">申请时退票手续费（比例）：</span> {{item.refundFeeStr}} <span v-if="item.refundFeeRatioStr">（{{item.refundFeeRatioStr}}）</span></span>
									<span class="ML20" v-if="item.afterSalesStatus == 3 || item.afterSalesStatus == 4"><span class="color-info">审核后确认退款金额：</span>{{item.recordRefundAmount}}</span>
									<span class="ML20" v-if="item.afterSalesStatus == 3 || item.afterSalesStatus == 4"><span class="color-info">审核后确认退票手续费（比例）：</span>{{item.recordRefundFeeStr}} <span v-if="item.recordRefundFeeRatioStr">（{{item.recordRefundFeeRatioStr}}）</span></span>
									<span v-if="item.refundTime" class="ML20"><span class="color-info">实际退款时间：</span>{{item.refundTime}}</span>
								</template>
								<template v-if="props.row.orderType == 3">
									<span><span class="color-info">申请退款数量：</span>{{item.refundNum}}</span>
									<span class="ML20"><span class="color-info">申请退款金额：</span>{{item.refundAmount}}</span>
									<span class="ML20" v-if="item.afterSalesStatus == 3 || item.afterSalesStatus == 4"><span class="color-info">审核后确认退款金额：</span>{{item.recordRefundAmount}}</span>
								</template>                                
                            </div>
                        </div>
						<div v-if="props.row.goodsAfterSales && props.row.goodsAfterSales.length > 0 && props.row.orderType == 3 ">
						    <div v-for="(t,i) in props.row.goodsAfterSales" :key="i" class="PD10">
						        <span><span class="color-info">周边售后状态：</span>{{goodsafterSalesStatus.get(t.status)}}</span>
								<span class="ML20"><span class="color-info">售后类型：</span>{{goodsAfterType.get(t.type)}}</span>
								<span class="ML20"><span class="color-info">售后原因：</span>{{t.reason}}</span>
								<span class="ML20"><span class="color-info">商品：</span>{{t.goodsInfo}}</span>
								<span class="ML20"><span class="color-info">SKU：</span>{{t.skuInfo}}</span>
								<span class="ML20"><span class="color-info">申请退款数量：</span>{{t.refundNum}}</span>
								<span class="ML20" v-if="t.createTime"><span class="color-info">售后申请时间：</span>{{t.createTime}}</span>
						        <span v-if="t.refundTime" class="ML20"><span class="color-info">实际退款时间：</span>{{t.refundTime}}</span>
						    </div>
						</div>
						<div class="ML20" v-if="props.row.afterSales && props.row.afterSales.length == 0 && !props.row.goodsAfterSales">暂无售后信息</div>
                    </template>
                </el-table-column>
				<el-table-column prop="paymentStatus" label="支付和订单状态" min-width="130">
				    <template slot-scope="scope">
						<p>支付状态：
							<span v-if="scope.row.paymentStatus == 1">未支付</span>
							<span v-else-if="scope.row.paymentStatus == 2" class="color-success" >已支付</span>
						</p>
						<p>订单状态：
							 {{orderStatus.get(scope.row.orderStatus)}}
						</p>
				    </template>
				</el-table-column>
				<el-table-column label="授权和候补状态" min-width="150">
					<template slot-scope="scope">
						<p>授权状态：
							<span v-if="scope.row.preAuthStatus == 1" class="color-warning">待授权</span>
							<span v-else-if="scope.row.preAuthStatus == 2" class="color-success">已授权</span>
							<span v-else-if="scope.row.preAuthStatus == 3" class="color-info">取消授权</span>
							<span v-else>无</span>
						</p>
						<p>
							候补状态：
							<span v-if="scope.row.alternateStatus == 1" class="color-warning">待候补</span>
							<span v-else-if="scope.row.alternateStatus == 2" class="color-black">候补中</span>
							<!-- 候补完成：hover 显示候补成功时间 -->
							<el-tooltip v-else-if="scope.row.alternateStatus == 3 && scope.row.alternateTime" effect="dark" :content="`候补成功时间: ${scope.row.alternateTime}`" placement="top">
								<span class="color-success hand">候补完成</span>
							</el-tooltip>
							<span v-else-if="scope.row.alternateStatus == 3" class="color-success">候补完成</span>
							<span v-else-if="scope.row.alternateStatus == 4" class="color-danger">候补失败</span>
							<span v-else>无</span>
						</p>
				    </template>
				</el-table-column>
				<el-table-column prop="consignStatusView" label="托售状态"></el-table-column>
				<!-- 定时购票状态：成功的 hover 显示定时购成功时间（出票时间） -->
				<el-table-column label="定时购票状态" min-width="130">
					<template slot-scope="scope">
						<el-tooltip v-if="scope.row.preBuyStatus == 3 && scope.row.preBuySuccessTime" effect="dark" :content="`定时购成功时间: ${scope.row.preBuySuccessTime}`" placement="top">
							<span class="hand">{{scope.row.preBuyStatusView}}</span>
						</el-tooltip>
						<span v-else>{{scope.row.preBuyStatusView}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="thirdAccountName" label="业务渠道"></el-table-column>
				<el-table-column prop="sn" label="订单编号" min-width="150"></el-table-column>
				<el-table-column prop="goodId" label="演/周/众 ID" min-width="120">
					<template slot-scope="scope">
					    <edit-dropdown :params="params" :id="scope.row.goodId" v-if="scope.row.orderType == 1"></edit-dropdown>
						<el-link :href="`/raise/project/edit/baseInfo/${scope.row.goodId}`"  v-if="scope.row.orderType == 2">{{scope.row.goodId}}</el-link>
						<el-link :href="`/goodsManage/goods/edit/${scope.row.goodId}`"  v-if="scope.row.orderType == 3">{{scope.row.goodId}}</el-link>
					</template>
				</el-table-column>
				<el-table-column prop="goodName" label="演/周/众 名称" show-overflow-tooltip min-width="250">
					<template slot-scope="scope">
					    <el-link class="ellipsis green" :href="`${sswap}/pages/activity/detail/detail?activityId=${scope.row.goodId}`" target="_blank"  v-if="scope.row.orderType == 1">{{scope.row.goodName}}</el-link>
						<span v-else>{{scope.row.goodName}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="skuID" label="SKU" show-overflow-tooltip min-width="250">
					<template slot-scope="scope">
						<span v-for="(item,index) in scope.row.orderDetailVO2s" :key="index">
							<span>{{item.skuName}}</span>
						</span>
					</template>
				</el-table-column>
				<el-table-column prop="payNum" label="总数"></el-table-column>
				<el-table-column prop="orderType" label="订单类型">
					<template slot-scope="scope">
					    <span v-if="scope.row.orderType == 1">演出</span>
					    <span v-else-if="scope.row.orderType == 2">众筹</span>
						<span v-else-if="scope.row.orderType == 3">周边</span>
						<span v-else-if="scope.row.orderType == 4">酒店</span>
						<span v-else-if="scope.row.orderType == 5">照片</span>
					</template>
				</el-table-column>
				<el-table-column prop="principalName" label="项目负责人" min-width="100"></el-table-column>					
				<el-table-column prop="thirdOrderId" label="外部渠道订单号" show-overflow-tooltip min-width="200"></el-table-column>
				<el-table-column prop="outTradeNo" label="支付平台交易号" show-overflow-tooltip min-width="200"></el-table-column>
				<el-table-column prop="payPlatformName" label="支付渠道"></el-table-column>
				<el-table-column prop="performeres" label="观影人" show-overflow-tooltip min-width="150"></el-table-column>
				<el-table-column prop="createTime" label="下单时间" min-width="180"></el-table-column>
				<el-table-column prop="payTime" label="支付时间" min-width="180"></el-table-column>
				<el-table-column prop="cancelTime" label="取消时间" show-overflow-tooltip min-width="200"></el-table-column>
				<el-table-column prop="createUser" label="购买人ID" min-width="180"  show-overflow-tooltip >
					<template slot-scope="scope">
						<el-link  @click="getUser(scope.row.createUser)" icon="el-icon-reading">{{scope.row.createUser}}</el-link>
					</template>
				</el-table-column>
				<el-table-column prop="telephone" label="手机号码" min-width="120"></el-table-column>
				<el-table-column prop="totalAmountStr" label="总价" min-width="120"></el-table-column>
				<el-table-column prop="totalDiscountAmountStr" label="优惠"></el-table-column>
				<el-table-column prop="realPayAmountStr" label="实际支付"></el-table-column>
				<el-table-column prop="customerName" label="收货人"  show-overflow-tooltip min-width="250"></el-table-column>
				<el-table-column prop="provinceName" label="收货省份"></el-table-column>
				<el-table-column prop="cityName" label="收货城市"></el-table-column>
				<el-table-column prop="address" label="收货地址" show-overflow-tooltip min-width="250"></el-table-column>
				<el-table-column prop="expressName" label="快递公司"></el-table-column>
				<el-table-column prop="expressNo" label="运单号" min-width="180"></el-table-column>
                <el-table-column fixed="right" width="200" label="操作" >
                    <template slot-scope="scope">                        
						<el-link :href="`/activityManage/order/edit/${scope.row.id}`"  v-if="scope.row.orderType == 1" icon="el-icon-edit" class="green MR10">管理</el-link>
						<el-link :href="`/raise/order/edit/${scope.row.id}`"  v-if="scope.row.orderType == 2" icon="el-icon-edit" class="green MR10">管理</el-link>
						<el-link :href="`/goodsManage/order/edit/${scope.row.id}`"  v-if="scope.row.orderType == 3" icon="el-icon-edit" class="green MR10">管理</el-link>
						<el-button
						    v-if="scope.row.ticketType == 2 && !scope.row.expressName && !scope.row.expressNo && scope.row.orderStatus != 6 && $utils.have('/activiOrder/deliverGoods')"
						    type="text"
						    size="small"
						    icon="el-icon-position"
						    @click="$refs.updateDeliverInfo.show(scope.row)"
						    >发货</el-button>
							
						<el-button
						    v-if="scope.row.orderType == 1 && $utils.have('/activiOrder/cancel') && scope.row.canCancelOrder == true  ||  (scope.row.preAuthStatus == 2 && scope.row.alternateStatus == 2 ) || ( scope.row.preAuthStatus == 2 && scope.row.preBuyStatus == 2 ) "
						    type="text"
						    size="small"
						    icon="el-icon-remove-outline"
						    @click="cancel(scope.row)"
						    >取消</el-button>
							<el-button type="text" size="small" icon="el-icon-share" @click="preview(scope.row.goodId)"  v-if="scope.row.orderType == 1">演出预览</el-button>  
                    </template>
                </el-table-column>
            </el-table>
        </div>
		<div v-if="dataList && dataList.length > 0 " class="page-pagination-box">
		    <el-pagination
		        background
		        @size-change="handleSizeChange"
		        @current-change="handleCurrentChange"
		        :current-page="currentPage"
		        :page-sizes="[5,10,15,20]"
		        :page-size="pageSize"
		        layout="total, sizes, prev, pager, next"
		        :total="pageTotal || 0">
		    </el-pagination>
		</div>
		<el-dialog title="取消订单" :visible.sync="dialogVisible" width="600px" center v-if="batchData">
			<div class="dialog-content">
				<div>
				   <p class="color-danger">取消之前请确认核对：</p>
				   <p class="MT10">演出ID：{{batchData.activityId}} <span v-if="batchData && batchData.orderStatus == 4 " class="color-danger">（实体票，已发货）</span></p>
				   <p class="MT10">演出名称：{{batchData.activityName}}</p>
				   <p class="MT10 color-danger">需取消订单数:{{batchData.cancelNum}},包含以下票品</p>
				   <div class="temp-table" v-if="batchData && batchData.ticketList && batchData.ticketList.length > 0">
				       <el-table
				           :data="batchData.ticketList"
				           style="width: 100%"
				           size="small"
				           border
				       >
				           <el-table-column prop="ticketName" label="票品&场次名称"></el-table-column>
				           <el-table-column prop="userName" label="观演人"></el-table-column>
				           <el-table-column prop="orderTime" label="下单时间"></el-table-column>	
				           <el-table-column prop="num" label="数量" min-width="50"></el-table-column>				           
				       </el-table>
				   </div>
				   <template v-if="batchData && batchData.cancelRecord && batchData.cancelRecord.length > 0">
				   <p class="MT20">当前演出用户取消记录:</p>
				   <div class="temp-table MT10">
					   <el-table
						   :data="batchData.cancelRecord"
						   style="width: 100%"
						   size="small"
						   border
					   >
						   <el-table-column prop="ticketName" label="票品&场次名称"></el-table-column>
						   <el-table-column prop="userName" label="观演人"></el-table-column>
						   <el-table-column prop="orderTime" label="下单时间"></el-table-column>
						   <el-table-column prop="num" label="已取消订单数" min-width="30"></el-table-column>						           
					   </el-table>
					   <el-link class="link color-blue"  :href="`/activityManage/order/list?searchType=1&searchValue=${batchData.activityId}&searchType2=5&searchValue2=${batchData.userId}&orderStatus=7`" target="_blank">点击查看已取消订单</el-link>
				   </div>
				   					   
				   </template>
					   <!-- 关联的权益票订单（取消主票会同步取消权益票订单） -->
					   <template v-if="batchData && batchData.benefitOrderList && batchData.benefitOrderList.length > 0">
					       <p class="MT10 color-danger">该订单有关联的权益票订单,取消后将会同步取消以下权益票订单:</p>
					       <div class="temp-table">
					           <el-table
					               :data="batchData.benefitOrderList"
					               style="width: 100%"
					               size="small"
					               border
					           >
					               <el-table-column prop="orderSn" label="权益票订单编号" min-width="150"></el-table-column>
					           <el-table-column prop="ticketName" label="票品名称" show-overflow-tooltip></el-table-column>
					           <el-table-column label="实付金额" min-width="90">
					               <template slot-scope="scope">{{ (scope.row.paidAmount / 10000).toFixed(2) }}元</template>
					           </el-table-column>
					           <el-table-column label="订单状态" min-width="80">
					               <template slot-scope="scope">{{ benefitOrderStatusText(scope.row.orderStatus) }}</template>
					           </el-table-column>
					       </el-table>
					       </div>
					   </template>
					   <div class="MT20">
					   <small class="color-danger">*</small>取消原由：
					   <el-input type="textarea" v-model="reason" placeholder="请填写取消原由" maxlength="100" class="MT10"></el-input>
				   </div>
				   <div class="MT20">
					   <small class="color-danger">*</small>请选择是否需要扣除手续费：
				   		<el-select v-model="isCalculateRefundFee" placeholder="请选择是否需要扣除手续费" size="small" style="width: 100%;" class="MT10">				   		   
				   		    <el-option label="不扣除手续费" value="0"></el-option>
				   		    <el-option label="需要扣除手续费" value="1"></el-option>
							<el-option label="手动设置扣款百分比" value="2"></el-option>
				   		</el-select>
						<div class="MT10 "><small v-if="batchData.refundRule == 1"><span class="color-danger">注意:当前演出设置了退款手续费规则，请酌情选择是否扣除手续费!</span></small></div>
						<div v-if="batchData.orderStatus == 4" class="MT10 color-danger">注意：当前有订单属于实体票订单且已经发货，请酌情选择是否取消!</div>
				   </div>
				   <div class="MT20" v-if="isCalculateRefundFee == 2">
				   	<small class="color-danger">*</small>扣款百分比：
				   	<el-input-number v-model="refundFeeRatio" :min="0" :max="100" :precision="2" controls-position="right" size="mini" style="width: 200px;"></el-input-number> %
				   	<span class="ML20" v-if="refundFeeRatio">{{ ((batchData.orderAmount * refundFeeRatio) / 1000000).toFixed(2) }} 元</span>
				   </div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="closePop()">取 消</el-button>
				<el-button type="primary" @click="batchCancelSubmit">确 定</el-button>
			</span>
		</el-dialog>
		<UpdateDeliverInfo ref="updateDeliverInfo" @onUpdate="getDataList"></UpdateDeliverInfo>
		<TicketWallet ref="ticketWallet"></TicketWallet>
		<H5Preview ref="H5Preview"></H5Preview>
    </div>
</template>

<script>

import EditDropdown from './components/edit-dropdown.vue';
import UpdateDeliverInfo from './components/updateDeliverInfo';
import TicketWallet from './components/ticketWallet';
import H5Preview from '@/components/H5Preview';
const defaultQuery = {    
    orderStatus:0,
	payStatus:0,
	searchType1:1,
	searchType2:1,
	searchType3:1,
	searchValue1:'',
	searchValue2:'',
	searchValue3:''
};
const defaultQuery2 = {
	pageNo:1,
}
export default {
    components:{EditDropdown,UpdateDeliverInfo,TicketWallet,H5Preview},
    data(){
        return{
            data: null,
            dataList: [],
			userInfo:null,
            params:{
                ...defaultQuery,
				searchValue1:this.$route.query.uphone ? this.$route.query.uphone : '',
				searchType2: parseInt(this.$route.query.searchType2 || 1),
				searchValue2: this.$route.query.searchValue2 || '',
            },
			params2:{
				...defaultQuery2,
			},
            listLoading: false,
			sswap:process.env.VUE_APP_SSWAP_URL,
			
			pageSize:10,
			pageTotal:null,
			currentPage:1,
			dialogVisible:false,
			batchData:null,
			reason:'主办同意单独退款',
			isCalculateRefundFee:'',
			ticketWalletData:[],
			refundFeeRatio:undefined
        }
    },
    mounted() {
        this.getDataList();
    },
	computed:{
	    orderStatus(){
	       return new Map([
	           [1,'待支付'],
	           [2,'待发货'],
	           [3,'部分发货'],
	           [4,'已发货'],
	           [5,'已完成'],
	           [6,'已过期'],
	           [7,'已取消'],
	           [8,'预购失败'],
	       ])
	    },
	    goodsafterSalesStatus(){
	        return new Map([
	            [0,'待审核'],
				[1,'已拒绝'],				
	            [2,'待退货'],
				[3,'待收货'],
	            [4,'待退款'],
	            [5,'已关闭'],
	        ])
	    },
		afterSalesStatus(){
		    return new Map([
		        [1,'待审核'],
				[2,'待退货'],				
		        [3,'待退款'],
				[4,'退款完成'],
		        [5,'已拒绝'],
		        [6,'已过期'],
				[7,'审核失败'],
				[8,'删除'],
		    ])
		},
		goodsAfterType(){
			return new Map([
				[1,'发货前 - 申请修改收货地址'],
				[2,'发货前 - 申请取消商品'],
				[3,'发货后 - 申请退货']
			])
		},
		source(){
		    return new Map([
				[-1,'后台取消'],
				[0,'演出变动'],
		        [1,'用户申请'],
		        [2,'托售成功'],
		        [3,'候补失败'],
		        [4,'定时购失败'],
		        [5,'过期支付'],
		        [6,'支付取消'],
				[7,'库存异常'],
		    ])
		}
	},
    methods: {
        //获取列表		
        getDataList() {
			const encodedParams = window.location.search.slice(1); // 去掉开头的 ?
			
			if (encodedParams) {
			  const decodedParams = decodeURIComponent(encodedParams);
			  const params = new URLSearchParams(decodedParams);
			  const uphone = params.get('uphone') || '';
			  this.params.searchValue1 = uphone
			}
			
            this.listLoading = true;
            this.$request({
                url: "/callCenter/search",
                method: "POST",
                data: {
                    ...this.params
                },
            })
			.then((res) => {
				const { state, msg, result } = res.data;
				if ( state == 1 ) {
					this.listLoading = false;
					this.data = result;					
					if( result && result.orderInfos ){
						
						this.pageTotal = result.orderInfos.length
						this.dataList = result.orderInfos || [];
						
					}
					if( result && result.userInfo){
						this.userInfo = result.userInfo || [];
						
					}
					
				} else {
					this.$message.error(msg || "请求失败");
				}
			})			
        },
		
		//选择pageSize
		handleSizeChange(e) {   
			this.pageSize = e;
		},
		handleCurrentChange (currentPage) {		    
			this.currentPage = currentPage;		      
		},
		goTicketWallet(id){
			this.$refs.ticketWallet.show(id)
		},
       getUser(id){
			this.$request({
			   url: "/callCenter/userInfo",
			   method: "POST",
			   params: {userId:id},
		})
		.then((res) => {
			const { state, msg, result } = res.data;
			if ( state == 1 && result) {
				
				this.userInfo = result || [];
			} else {
				this.$message.error(msg || "请求失败");
			}
		})
		.catch(() => {
			this.$message.error("请求错误");
		})
		.finally(() => {
			this.listLoading = false;
		});
	},
        //搜索
        search() {
           this.pageSize = 10
		   this.currentPage = 1
		   this.dataList = []
           this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {
                ...defaultQuery
            };
            this.dataList = []
			this.userInfo = null
            this.getDataList();
        },
		//权益票订单状态文案
		benefitOrderStatusText(status){
			const _map = { 1: '待处理', 2: '待发货', 3: '部分发货', 4: '已发货', 5: '已完成', 6: '已过期', 7: '已取消' };
			return _map[status] || '-';
		},
		cancel(data){
			if( (data.preAuthStatus == 2 && data.alternateStatus == 2 ) || ( data.preAuthStatus == 2 && data.preBuyStatus == 2 ) ){
				this.cancelFun2(data)
			}else{
			this.$request({
				url: "/activiOrder/batchCancelCheck",
				method: "POST",
				data: {
				    searchType:4,
					searchValue:data.sn
				},
			})
				.then((res) => {
					const { state, msg, result } = res.data;
					if (state == 1) {
						
						if( result.errorInfo){
							this.$alert(result.errorInfo, '取消订单', {confirmButtonText: '知道了'});
						}
						if( result.ticketList && result.ticketList.length > 0 ){
							this.batchData = result
							
							this.dialogVisible = true
						}
						if( result.ticketList && result.ticketList.length == 0 && result.cancelNum == 0 ){
							this.$message.warning("暂无可处理的订单");
						}
					} else {
						
						this.$message.error(msg || "请求失败");
					}
				})
				.catch(() => {
					this.$message.error("请求错误");
				})	
			}
		},
		batchCancelSubmit(){
			if( this.isCalculateRefundFee == ''){
				return this.$message.error("请选择是否需要扣除手续费");
			}
			if( this.reason == '' ){
				return this.$message.error("取消原由不能为空");
			}
			//关联权益票订单确认（取消主票会同步取消关联的权益票订单）
			if( this.batchData.benefitOrderList && this.batchData.benefitOrderList.length > 0 ){
				const _sns = this.batchData.benefitOrderList.map(v => v.orderSn).join('、');
				this.$confirm(`该订单有关联的权益票订单:<span class="color-danger">${_sns}</span>,将会同步取消对应权益票订单,确认取消?`, '取消订单', {
					type: 'warning',
					confirmButtonText: '确认取消',
					cancelButtonText: '再想想',
					showClose: false,
					customClass: 'mpop',
					closeOnClickModal: false,
					dangerouslyUseHTMLString: true,
				}).then(() => {
					this.batchCancelSubmitRun();
				}).catch(() => {})
				return;
			}
			this.batchCancelSubmitRun();
		},
		batchCancelSubmitRun(){
			if( this.batchData.orderStatus == 4 ){
				this.$confirm(`注意:当前订单包含<span class="color-danger">实体票订单，且已经发货</span>，取消以后可能存在无法收回门票的风险。<br>是否确认<span class="color-danger">继续取消</span>?`, '取消订单', {
					type: 'wraning',
					confirmButtonText: '继续取消',
					cancelButtonText:'返回',
					showClose:false,
					customClass:'mpop',
					closeOnClickModal: false,
					dangerouslyUseHTMLString: true,					
				}).then(() => {
					this.cancelFun()
				}).catch(() => {
					this.closePop()
				}) 
				
			}else{
				this.cancelFun()
			}			
			    
		},
		cancelFun(){
			if (this.isCalculateRefundFee == 2) {
				if (this.refundFeeRatio == undefined ) {
					return this.$message.warning('请填写扣款百分比');					
				}
				if (this.refundFeeRatio == 0) {
					return this.$message.warning('扣款百分比必须大于0');					
				}			        
			}
			this.batchLoading2 = true
			this.$request({
			    url: "/activiOrder/cancel",
			    method: "POST",
			    params:{
					orderId:this.batchData.orderIds[0],					
					isCalculateRefundFee:this.isCalculateRefundFee,
					reason:this.reason,
					refundFeeRatio:this.refundFeeRatio
				} 
			})
			    .then((res) => {
			        const { state, msg, result } = res.data;
			        if (state == 1) {
						this.$message.success("操作成功");
						this.getDataList();
						this.dialogVisible = false
						this.isCalculateRefundFee = ''
						this.reason = '主办同意单独退款'
						this.refundFeeRatio = undefined
						
			        } else {			            
			            this.$message.error(msg || "请求失败");						
						this.isCalculateRefundFee = ''
						this.reason = '主办同意单独退款'
						this.refundFeeRatio = undefined
			        }
			    })
			    .catch(() => {
			        this.$message.error("请求错误");
			    })
		},
		// 取消授权订单(候补中、定时购中)  data.alternateStatus == 2 ) || ( data.preAuthStatus == 2 && data.preBuyStatus == 2 ) ){
		cancelFun2(data){			
			let text = '';
			if (data.alternateStatus === 2) {
			  text = '候补中';
			} else if (data.preBuyStatus === 2) {
			  text = '定时购中';
			}
			this.$confirm(`注意:取消该预授权订单，<span class="color-danger"> ${text} </span>将自动失败，并释放预授权.是否确认<span class="color-danger">继续取消?</span>`, '取消订单', {
				type: 'wraning',
				confirmButtonText: '继续取消',
				cancelButtonText:'取消',
				showClose:false,
				customClass:'mpop',
				closeOnClickModal: false,
				dangerouslyUseHTMLString: true,	
			}).then(() => {
				this.$request({
					url: '/activiOrder/cancelAuth',
					method: 'POST',
					params: {
						orderId:data.id
					}
				}).then(res => {
					const { state, msg } = res.data;
					if( state == 1 ){
						this.$message.success("操作成功");
						this.getDataList();
						this.dialogVisible = false
						
					}else{
						this.$message.error(msg || "请求失败");
						
					}
				})
				
			}).catch(() => {
				
			})
			
			
		},
		closePop(){
			this.dialogVisible = false			
			this.isCalculateRefundFee = ''
			this.reason = '主办同意单独退款'
			this.refundFeeRatio = undefined
		},
		preview(id){
			var url = this.sswap+'/pages/activity/detail/detail?activityId='+id
			this.$refs.H5Preview.show(url)
		}
		
    }
}
</script>

<style lang="scss" scoped>
.green{
	color: #1FBB7D;
}
.MR10{
	margin-right: 10px;
	display: inline-block;
	vertical-align: middle;
}
.el-card{
    .el-col{
        line-height: 28px;
    }
}
::v-deep .el-table__row expanded{
    div{
        line-height: 30px;
    }
}
::v-deep .color-blue{	
	color:#409EFF;
	font-size: 12px
}
.temp-table{
	margin-top: 20px;
	max-height: 300px;
	min-height: 100px;
	overflow-y:auto;
	::v-deep .el-table,.el-table thead{
		color:#f00
	}	
}
.color-black{
	color: #000;
	font-weight: bold;
}
</style>
